import { cn } from '@module/lib/utils';
import React from 'react';

type NoticeItem =
  | {
      type: 'title';
      value: string;
    }
  | string;

export type NoticeList = NoticeItem[];

interface Props {
  noticeList: NoticeList;
  className?: string;
  classNames?: {
    title?: string;
    content?: string;
  };
  title?: string;
  boldIndex?: number[];
  customElement?: React.ReactNode;
  withLeadingDot?: boolean;
}

function NoticeCard({
  noticeList,
  className,
  title,
  boldIndex,
  customElement,
  withLeadingDot = true,
  classNames,
}: Props) {
  if (noticeList.length < 1) return;
  return (
    <div className={cn('w-full rounded-[6px] bg-colorBg04 py-6 pr-[30px] text-[14px] leading-[1.6]', className)}>
      {title && (
        <span className={cn('block pb-3 pl-6 font-medium text-[16px] text-colorFg07', classNames?.title)}>{title}</span>
      )}
      {noticeList.map((item, index) => (
        <React.Fragment key={typeof item === 'string' ? item : index}>
          {typeof item !== 'string' && item.type === 'title' && (
            <div className='mb-3 flex pl-[30px]'>
              <div className='-tracking-[1px] font-medium text-colorFg07'>{item.value}</div>
            </div>
          )}
          {typeof item === 'string' && (
            <div className={cn('mb-1 flex pl-[30px] text-[#777]', classNames?.content)}>
              {withLeadingDot && <span className='mr-2'>·</span>}
              <div
                dangerouslySetInnerHTML={{ __html: item }}
                className={cn('-tracking-[1px] whitespace-pre-wrap', {
                  'font-medium': boldIndex?.includes(index),
                })}
              />
            </div>
          )}
        </React.Fragment>
      ))}
      {customElement}
    </div>
  );
}

export default NoticeCard;
